import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import "./CampaignLeadList.scss"; 
// Example items, to simulate fetching from another resources.
function PaginatedItems({ itemsPerPage, currentPageData, itemOffset, setItemOffset, items }) {
    // We start with an empty list of items.
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const tempItem = useRef();

    const setCurrentItemsAndPageCount = () => {
        const endOffset = itemOffset + itemsPerPage;
        currentPageData(items?.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items?.length / itemsPerPage));
    };
    tempItem.current = setCurrentItemsAndPageCount;

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setCurrentPage(event.selected);
        setItemOffset(newOffset);
    };

    useEffect(() => {
        tempItem.current();
        // Fetch items from another resources.
    }, [itemOffset, itemsPerPage, items]);

    useEffect(() => {
        setCurrentPage(0);
    }, [itemsPerPage]);

    
    return (
        <>
            <ReactPaginate
                nextLabel=">"
                forcePage={currentPage}
                onPageChange={handlePageClick}
                pageRangeDisplayed={0}
                marginPagesDisplayed={0}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                className="d-flex flex-row justify-content-between pagination-list"
                activeClassName={"bg-primary text-light  my-auto rounded"}
                disabledClassName={"pagination__link--disabled"}
            />
        </>
    );
}
export default PaginatedItems;